import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { COMMERCIAL_RANGE_LABELS, FEE_CODE_OPTIONS } from '../../constants/filterOptions';
import RangeSelectArea from 'components/FilterFields/RangeSelectArea';
import { Divider, Typography } from '@mui/material';
import SelectFilter from 'components/FilterFields/SelectFilter';

const FEE_CODE_PARAM = 'feeCode';
function CommercialFilter(props) {
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
            data-testid="commercial-filters"
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Commercial</Typography>
            <Grid container spacing={3}>
                <Grid item size={4}>
                    <SelectFilter
                        title="Fee Code"
                        subTitle="Select an option or manually enter a value"
                        comparableType={props.comparableType}
                        attrName={FEE_CODE_PARAM}
                        options={FEE_CODE_OPTIONS}
                    />
                </Grid>
                {
                    Object.keys(COMMERCIAL_RANGE_LABELS).map(value => {
                        return (
                            <Grid item size={4} key={value}>
                                <RangeSelectArea
                                    comparableType={props.comparableType}
                                    label={COMMERCIAL_RANGE_LABELS[value]}
                                    attrName={value}
                                    sx={{
                                        width: '100%',
                                    }}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
        </Box>
    );
}

export default React.memo(CommercialFilter);